import { createIntl, createIntlCache } from "react-intl";
import fa_message from "./locales/fa.json";
import en_message from "./locales/en.json";
//TODO: fetch messages dynamically
const cache = createIntlCache();
let locale = localStorage.getItem("localeAdmin") || "FA";
let intl = {};
switch (locale.toUpperCase()) {
  case "FA":
    intl = createIntl({ messages: fa_message, locale });
    break;
  case "EN":
    intl = createIntl({ messages: en_message, locale });
    break;
  default:
    intl = createIntl({ messages: fa_message, locale: "FA" });
    break;
}
// Translate Function
export const __t = (str, values) => {
  if (!!str) {
    return intl.formatMessage(
      {
        id: str,
        defaultMessage: str,
      },
      values
    );
  }
  return "";
};
